// Silences the benign "ResizeObserver loop ..." browser notification.
//
// This is NOT a real crash — the browser emits it when a ResizeObserver callback
// triggers another layout change within the same frame (common with third-party
// embeds like the Travelpayouts widgets and some Radix UI popovers). React's dev
// error overlay listens to window 'error' and shows it as a scary runtime error.
//
// Two layers of defence:
//  1) Wrap ResizeObserver so its callback runs on the next animation frame, which
//     breaks the synchronous loop that produces the notification in the first place.
//  2) As a safety net, stop the benign message from bubbling to the dev overlay /
//     unhandledrejection handlers. All other errors pass through untouched.

const BENIGN = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

// 1) Debounce ResizeObserver callbacks to the next frame.
if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'function') {
  const Native = window.ResizeObserver;
  window.ResizeObserver = class extends Native {
    constructor(callback) {
      let frame = 0;
      super((entries, observer) => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

// 2) Swallow the benign error only (everything else is left alone).
if (typeof window !== 'undefined') {
  window.addEventListener(
    'error',
    (e) => {
      if (e && e.message && BENIGN.test(e.message)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true, // capture phase: run before the dev overlay's handler
  );
}

export {};
